import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import moment from 'moment';
import DrawerModal from '@shared/components/modals/drawer-modal/drawer-modal.vue';
import PosSessionForm from '@pos/components/forms/pos-session-form/pos-session-form.vue';
import { getProp } from '@shared/helpers/operators';

@Component({
  name: 'bpc-close-pos-session-drawer',
  components: {
    'bpc-drawer-modal': DrawerModal,
    'bpc-pos-session-form': PosSessionForm,
  },
})
export default class ClosePosSessionDrawerMethods extends Vue {
  $refs: {
    posSessionForm: InstanceType<typeof PosSessionForm> & {
      saveEntity(): void;
      formModel: any;
    };
  };

  showClosePosSessionDrawer: boolean = false;
  isClosingSession: boolean = false;
  keyClosePosSessionForm: number = 1;
  closePosSessionFormModelLoaded: boolean = false;

  onPosSessionToCloseLoaded(event) {
    setTimeout(() => {
      if (getProp(this.$refs.posSessionForm.formModel, 'status') !== 'reopened') {
        this.$set(this.$refs.posSessionForm.formModel, 'end_date', moment().format('YYYY-MM-DD'));
        this.$set(this.$refs.posSessionForm.formModel, 'end_time', moment().format('HH:mm'));
      }
      this.$set(this.$refs.posSessionForm.formModel, 'status', 'closed');
      this.closePosSessionFormModelLoaded = true;
    });
  }

  onClickCloseSession(): void {
    this.closePosSessionFormModelLoaded = false;
    this.keyClosePosSessionForm++;
    this.showClosePosSessionDrawer = true;
  }

  onFormCloseSession(): void {
    this.showClosePosSessionDrawer = false;
  }

  onFormSaveSession(): void {
    this.$refs.posSessionForm.saveEntity();
  }

  onClosingSession(): void {
    this.isClosingSession = true;
  }

  onErrorClosingSession(): void {
    this.$nextTick().then(() => {
      this.isClosingSession = false;
    });
  }

  onClosedSession(): void {
    this.$store.commit('pos/closeDrawer');
    this.$store.commit('pos/clearOpenPosSession');
    this.isClosingSession = false;
    this.showClosePosSessionDrawer = false;
    this.$store.commit('pos/toggleCloseSessionDrawer');
    this.$store.commit('pos/toggleModalsOpened');
    this.$root.$emit('refresh-pos-session-list');
  }

  toggleCloseSessionDrawer() {
    this.$store.commit('pos/toggleCloseSessionDrawer');
    this.$store.commit('pos/toggleModalsOpened');
  }

  get showCloseSessionDrawer(): boolean {
    return this.$store.getters['pos/showCloseSessionDrawer'];
  }

  @Watch('showCloseSessionDrawer')
  onShowCloseSessionDrawer() {
    if (this.showCloseSessionDrawer === true) {
      this.keyClosePosSessionForm++;
    }
  }
}
